import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Place } from '../../../core/interfaces/place.interface';

@Component({
  selector: 'app-stock-page',
  templateUrl: './stock-page.component.html',
  styleUrls: ['./stock-page.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockPageComponent {
  selectedTab: number = 0;

  @Input() authorization;
  @Input() location: Place;
  @Input() totalItems: number;
  @Input() isLoading: boolean = false;
  @Input() items;
  @Input() locations: Place[] = [];

  @Output() filterStock = new EventEmitter();
}
